import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { company, footerNavigation, socialLinks } from "../../data/site";
import { base, localHref } from "../../lib/links";
import ExternalLink from "../ui/ExternalLink";
import Logo from "./Logo";

const socialIcons = { Linkedin, Facebook, Instagram, Youtube };

function Column({ title, children }) {
  return (
    <div>
      <h2 className="tag mb-3 text-[13px] tracking-[0.1em] text-white">
        {title}
      </h2>
      {children}
    </div>
  );
}

/** Graphite footer: wordmark and "make building easier", office, contact. */
export default function SiteFooter() {
  const { address } = company;
  return (
    <footer className="bg-ink px-4 pt-14 pb-10 text-[15px] text-on-dark-muted sm:px-6">
      <div className="mx-auto max-w-280">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="flex flex-col items-start gap-4">
            <Logo tone="light" aria-label="Xeratec home" />
            <img
              src={`${base}brand/make-building-easier.png`}
              alt="Make building easier"
              width="560"
              height="118"
              loading="lazy"
              className="-ml-2 h-9 w-auto"
            />
          </div>
          <Column title="Office">
            <a
              href={company.mapsUrl}
              className="leading-relaxed transition-colors hover:text-yellow"
            >
              {address.street}
              <br />
              {address.city}, {address.region} {address.postalCode}
            </a>
          </Column>
          <Column title="Contact">
            <p className="leading-relaxed">
              <a
                href={company.phone.href}
                className="transition-colors hover:text-yellow"
              >
                {company.phone.display}
              </a>
              <br />
              <a
                href={`mailto:${company.email}`}
                className="text-white underline decoration-yellow decoration-2 underline-offset-4 transition-colors hover:text-yellow"
              >
                {company.email}
              </a>
            </p>
          </Column>
          <Column title="Follow">
            <div className="flex gap-2.5">
              {socialLinks.map(({ label, href }) => {
                const Icon = socialIcons[label];
                return (
                  <ExternalLink
                    key={label}
                    href={href}
                    aria-label={`Xeratec on ${label === "Linkedin" ? "LinkedIn" : label === "Youtube" ? "YouTube" : label}`}
                    className="grid size-10 place-items-center rounded-brand bg-white/8 text-white transition-colors hover:bg-yellow hover:text-ink"
                  >
                    <Icon size={18} />
                  </ExternalLink>
                );
              })}
            </div>
          </Column>
        </div>
        <div className="mt-12 flex flex-col-reverse items-start justify-between gap-5 border-t border-white/12 pt-7 text-sm md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Xeratec. All rights reserved.</p>
          <nav
            aria-label="Footer navigation"
            className="flex flex-wrap gap-x-6 gap-y-2"
          >
            {footerNavigation.map(({ label, href }) => (
              <a
                key={href}
                href={localHref(href)}
                className="transition-colors hover:text-white"
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
